module.exports = __webpack_public_path__ + "img/huanyou.05429a02.png";